import {TranslationNamespaces} from '@lib/locales';
import {
  CancellableWorkdayStatus,
  LocalDateString,
  OfficeWorkday,
  Workday,
  WorkdayStatus,
} from '@lib/store/src/data/timeslots/apiTypes';
import {TFunction} from 'i18next';

export const extractWorkdaysForDay = (groupMemberWithWorkdays: Workday[], day: LocalDateString) => {
  return groupMemberWithWorkdays.filter((wd) => wd.localStart.startsWith(day));
};

export const extractWorkdayStatus = (workdays: Workday[]) => {
  const statusPriority: CancellableWorkdayStatus[] = ['OfficeDay', 'WorkingRemotely', 'NotWorking', 'Unknown'];

  return workdays.reduce<CancellableWorkdayStatus>((acc, current) => {
    const highestIndex = statusPriority.indexOf(acc) !== -1 ? statusPriority.indexOf(acc) : 3;
    const currentIndex = statusPriority.indexOf(current.status) !== -1 ? statusPriority.indexOf(current.status) : 3;

    return currentIndex < highestIndex ? current.status : acc;
  }, 'Unknown');
};

export const getOfficeLabel = (
  workdayStatus: CancellableWorkdayStatus,
  officeDay: OfficeWorkday | undefined,
  t: TFunction<TranslationNamespaces, undefined>,
) => {
  switch (workdayStatus) {
    case 'WorkingRemotely':
      return t('workplace:WorkingRemotely');
    case 'NotWorking':
      return t('workplace:NotWorking');
    case 'OfficeDay':
      return officeDay ? officeDay.buildingName : '';
    default:
      return t('workplace:Unknown');
  }
};
